export default (from_search) => {
  const prefix = (from_search) ? 'overlay-search-' : '';

  const setFocusToNextMenuItem = ($item) => {
    // console.log('setFocusToNextMenuItem', $item);
  
    const total_items_in_element = $item.closest('.filters-panel-v2__subnav').find('li').length;
    const element_index = $item.index();
  
    // console.log('total_items_in_element', total_items_in_element);
    // console.log('element_index', element_index);
  
    if (element_index + 1 < total_items_in_element) {
      $item.parent().find(`[data-${prefix}filter-options]`).eq(element_index + 1).find(`[data-clickable-option]`).first().trigger('focus');
    } else {
      // We move to the sorting menu
      $(`[data-${prefix}show-desktop-sort-nav]`).trigger('click');
    }
  };
  
  const setFocusToPreviousMenuItem = ($item) => {
    const element_index = $item.index();
    // console.log('setFocusToPreviousMenuItem', element_index);
  
    if (element_index - 1 >= 0) {
      $item.parent().find(`[data-${prefix}filter-options]`).eq(element_index - 1).find(`[data-clickable-option]`).last().trigger('focus');
    }
  };
  
  // const setFocusToFirstSubMenuItem = ($item) => { 
  //   $item.find('[data-clickable-option-li]').first().find('[data-clickable-option]').trigger('focus');
  // };
  
  const setFocusToNextSubMenuItem = ($item) => {
    const total_items_in_element = $item.closest(`[data-${prefix}filter-options-items]`).find('li').length;
    const element_index = $item.parent().index();
    // console.log('total_items_in_element', total_items_in_element);
    // console.log(`setFocusToNextSubMenuItem element_index width value ${$item.data('option-value')}`, element_index);
  
    if (element_index + 1 < total_items_in_element) {
      $item.closest(`[data-${prefix}filter-options-items]`).find('li').eq(element_index + 1).find('[data-clickable-option]').trigger('focus');
    } else {
      // Go to next menu item
      setFocusToNextMenuItem($item.closest(`[data-${prefix}filter-options]`));
    }
  };
  
  const setFocusToPreviousSubMenuItem = ($item) => {
    const element_index = $item.parent().index();
    // console.log(`setFocusToPreviousSubMenuItem element_index width value ${$item.data('option-value')}`, element_index);
  
    if (element_index - 1 >= 0) {
      $item.closest(`[data-${prefix}filter-options-items]`).find('li').eq(element_index - 1).find('[data-clickable-option]').trigger('focus');
    } else {
      // Go to previous menu item
      setFocusToPreviousMenuItem($item.closest(`[data-${prefix}filter-options]`));
    }
  };
    
  // Select a subnav menu item
  $(document).on('keydown', `[data-${prefix}filter-options] [data-clickable-option]`, (e) => {
    const key = e.which;
    const $item = $(e.currentTarget);
    console.log('key', key);
  
    switch (key) {
      // Enter / spacebar
      case 13:
      case 32:
        $item.find('input').trigger('click');
        break;

      // left
      case 37:
        setFocusToPreviousSubMenuItem($item);
        break;
  
      // right
      case 39:
        setFocusToNextSubMenuItem($item);
        break;
  
      // down
      case 40:
        setFocusToNextSubMenuItem($item);
        break;
  
      // up
      case 38:
        setFocusToPreviousSubMenuItem($item);
        break;
    }
  });

  $(document).on('change', '[data-option-ada]', (e) => {
    const $item = $(e.currentTarget);
    $item.closest('.newfilter-checkbox').trigger('click');
    // if ($item.checked) {
    //   // checkbox is checked
    // }
  });

  $(document).on('keypress', `[data-${prefix}show-desktop-filter-nav]`, (e) => {
    const key = e.which;
  
    // Enter / spacebar
    if (key === 13 || key === 32) {
      const $item = $(e.currentTarget);
      $item.trigger('click');
    }
  });
};
